import { useEffect, useState } from "react";
import { useDebounce } from "use-debounce";
import { omitBy } from "lodash";

import { EventOrderStatus } from "../types";
import { EventParticipantStatus } from "@/modules/eventsV2/constants";

export type EventFiltersType = Partial<{
  search: string;
  status: EventOrderStatus | EventParticipantStatus;
  statuses: EventOrderStatus[];
  date: string;
  type: string;
}>;

export enum ChangeTypes {
  Debounce = 'debounce',
}

export type FiltersChangeType = (inputs: EventFiltersType, type?: ChangeTypes.Debounce) => void

export const useEventFilters = () => {
  const [filters, setFilters] = useState<EventFiltersType>({});

  const [searchValue, setSearchValue] = useState(filters.search);
  const [debouncedSearchValue] = useDebounce(searchValue, 300);

  useEffect(() => {
    filtersChange({ search: debouncedSearchValue || '' });
  }, [debouncedSearchValue]);

  const filtersChange: FiltersChangeType = (inputs, type) => {
    if (type === ChangeTypes.Debounce) {
      setSearchValue(inputs.search);
      return;
    }

    setFilters(omitBy(
      { ...filters, ...inputs },
      (value) => value === '')
    );
  }

  return {
    filters,
    filtersChange,
  };
};
